import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { AdminPanel } from '../../core/interfaces';
import { TSP } from '../../core/models';
import { EntityListComponent } from '../../shared/components/entity-list/entity-list.component';

@Component({
  selector: 'app-regions',
  imports: [CommonModule, EntityListComponent],
  template: `
    <app-entity-list
      title="Regions"
      [columns]="columns"
      [data]="regions"
      [totalItems]="totalItems"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [loading]="loading"
      (pageChange)="onPageChange($event)"
      (sortChange)="onSortChange($event)"
      (searchChange)="onSearch($event)"
      (action)="onAction($event)"
    >
    </app-entity-list>
  `,
})
export class RegionsComponent implements OnInit {
  public columns: AdminPanel.Entity.EntityColumn[] = [
    { key: 'id', label: 'ID', sortable: true, sortKey: 'id', type: 'number' },
    { key: 'name', label: 'Name', sortable: true, sortKey: 'name', type: 'text' },
    { key: 'country.name', label: 'Country', sortable: true, sortKey: 'countryId', type: 'text' },
    { key: 'code', label: 'Code', sortable: false, type: 'text' },
    { key: 'area', label: 'Area (km²)', sortable: false, type: 'number' },
  ];

  public regions: TSP.Internal.Dictionary.Region.Details[] = [];
  public totalItems = 0;
  public pageSize = 10;
  public pageIndex = 0;
  public loading = false;

  public ngOnInit(): void {
    this.loadData();
  }

  public loadData(): void {
    // TODO: Replace with actual API call
    this.loading = true;
    setTimeout(() => {
      this.regions = [
        {
          id: 1,
          name: 'Kyiv Region',
          country: {
            id: 1,
            name: 'Ukraine',
          },
          enName: 'Kyiv Region',
          ruName: 'Киевская область',
          ukName: 'Київська область',
          synonymsAndTranslations: ['Kyiv Region'],
          cities: [],
          countryName: 'Ukraine',
          countryId: 1,
        },
        {
          id: 2,
          name: 'Lviv Region',
          country: {
            id: 1,
            name: 'Ukraine',
          },
          enName: 'Lviv Region',
          ruName: 'Львовская область',
          ukName: 'Львівська область',
          synonymsAndTranslations: ['Lviv Region'],
          cities: [],
          countryName: 'Ukraine',
          countryId: 1,
        },
      ];
      this.totalItems = 2;
      this.loading = false;
    }, 500);
  }

  public onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadData();
  }

  public onSortChange(sort: Sort): void {
    console.log('Sort changed:', sort);
    this.loadData();
  }

  public onSearch(searchTerm: string): void {
    console.log('Search:', searchTerm);
    this.loadData();
  }

  public onAction(action: AdminPanel.Entity.EntityAction): void {
    switch (action.type) {
      case 'create':
        console.log('Create new region');
        // TODO: Open dialog for creating new region
        break;
      case 'edit':
        console.log('Edit region:', action.item);
        // TODO: Open dialog for editing region
        break;
      case 'delete':
        console.log('Delete region:', action.item);
        // TODO: Open confirmation dialog and delete region
        break;
    }
  }
}
